import { render, staticRenderFns } from "./Invoicemangerdetail.vue?vue&type=template&id=6dd9a484&scoped=true"
import script from "./Invoicemangerdetail.vue?vue&type=script&lang=js"
export * from "./Invoicemangerdetail.vue?vue&type=script&lang=js"
import style0 from "./Invoicemangerdetail.vue?vue&type=style&index=0&id=6dd9a484&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd9a484",
  null
  
)

export default component.exports